// import { SUBMIT_VALIDATE1 } from "@/api/ideation/ideation";
import {
	ADD_DATA,
	SUBMIT_VALIDATE1,
	SUBMIT_VALIDATE2,
	GET_ALL_DATA,
	UPDATE_DATA,
	DELETE_DATA,
	GET_DETAIL,
	GET_DEFAULT,
	GET_VALIDATION,
	GET_QUESIONER_GG,
	SUBMIT_VALIDATE_BUSINESS_TF,
} from "@/api/master/quesioner";
import querystring from "query-string";

const state = {
	list: [],
	quesioner_gg: [],
	listDefault: {},
	validation: {},
	detail: {},
};

const mutations = {
	SET_LIST: (state, payload) => {
		state.list = payload;
	},
	SET_VALIDATION: (state, payload) => {
		state.validation = payload;
	},
	SET_QUESIONER_GG: (state, payload) => {
		state.quesioner_gg = payload;
	},
	SET_LIST_DEFAULT: (state, payload) => {
		state.listDefault = payload;
	},
	SET_DETAIL: (state, payload) => {
		state.detail = payload;
	},
	// UPDATE_DATA(args) {
	// 	state.list.forEach((data, i) => {
	// 		if (data.id == args.id) {
	// 			console.log(args)
	// 			state.list[i] = JSON.stringify(JSON.parse(args));
	// 		}
	// 	})
	// }
};

const actions = {
	GET_LIST: async ({ commit }, params) => {
		params = querystring.stringify(params);
		const resp = await GET_ALL_DATA(params);
		const data = resp.data.data;
		commit("SET_LIST", data);
	},

	GET_VALIDATION: async ({ commit }, params) => {
		const resp = await GET_VALIDATION(params);
		const data = resp.data.data;
		commit("SET_VALIDATION", data);
	},

	GET_LIST_DEFAULT: async ({ commit }, params) => {
		params = querystring.stringify(params);
		const resp = await GET_DEFAULT(params);
		const data = resp.data.data;
		commit("SET_LIST_DEFAULT", data);
	},

	GET_QUESIONER_GG: async ({ commit }, params) => {
		// params = querystring.stringify(params);
		const resp = await GET_QUESIONER_GG(params);
		const data = resp.data.data;
		commit("SET_QUESIONER_GG", data);
	},

	CREATE_DATA: async ({ commit }, args) => {
		return await ADD_DATA(args);
	},
	SUBMIT_VALIDATE1: async ({ commit }, args) => {
		return await SUBMIT_VALIDATE1(args);
	},
	SUBMIT_VALIDATE_BUSINESS_TF: async ({ commit }, args) => {
		return await SUBMIT_VALIDATE_BUSINESS_TF(args);
	},
	SUBMIT_VALIDATE2: async ({ commit }, args) => {
		return await SUBMIT_VALIDATE2(args);
	},
	UPDATE_DATA: async ({ }, args) => {
		return await UPDATE_DATA(args);
	},
	DELETE_DATA: async ({ }, id) => {
		return await DELETE_DATA(id);
	},
	GET_DETAIL: async ({ commit }, id) => {
		const resp = await GET_DETAIL(id);
		const data = resp.data.data;
		commit("SET_DETAIL", data);
	},
	// CREATE_DATA: async ({ commit }, args) => {
	// 	var id = state.list.length + 1
	// 	args.id = id
	// 	state.list.push(args)
	// 	// return await ADD_DATA(args);
	// },
	// UPDATE_DATA: async ({ commit }, args) => {
	// 	state.list.forEach(item => {
	// 		if (item.id == args.id) {
	// 			// console.log(args)
	// 			commit("UPDATE_DATA", args)
	// 		}
	// 	})
	// 	// return await UPDATE_DATA(args);
	// },

	// DELETE_DATA: async ({ }, id) => {
	// 	state.list.forEach((data, i) => {
	// 		if (data.id == id) {
	// 			state.list.splice(i, 1);
	// 		}
	// 	})
	// 	// return await DELETE_DATA(id);
	// },
};

const getters = {
	list: (state) => state.list,
	listDefault: (state) => state.listDefault,
	detail: (state) => state.detail,
	validation: (state) => state.validation,
	quesioner_gg: (state) => state.quesioner_gg,
};

export default {
	namespaced: true,
	state,
	actions,
	mutations,
	getters,
};
